import { Carousel as AntCarousel } from 'antd'
import styled from 'styled-components'

import type { T_CarouselProps } from '@/components/carousel/carousel'


export const SC_Carousel = styled(
  (props: T_CarouselProps) => <AntCarousel {...props} />
)`
  margin: 65px 16px -20px;
  height: 130px;
  border-radius: 24px 24px 0px 0px;
  background-color: transparent;

  .slick-dots {
    margin-bottom: 20px;
  }

  .slick-slide img {
    width: 100%;
    height: 130px;
    object-fit: cover;
    border-radius: 24px 24px 0 0;
  }
`
